import { useOptionalPreferences } from '../contexts/PreferencesContext';
import { DEFAULT_UNIT_SYSTEM, UNIT_SYSTEM_CHOICES } from '../config/preferenceDefs';

const KNOWN = new Set(UNIT_SYSTEM_CHOICES.map(choice => choice.value));

/** 'default' | 'metric' | 'imperial' — anything else reads as the default. */
export const normalizeUnitSystem = value => (KNOWN.has(value) ? value : DEFAULT_UNIT_SYSTEM);

/**
 * The signed-in user's unit-system preference for measurement display
 * ('default' | 'metric' | 'imperial'), re-rendering the caller when it
 * changes. Mirrors useDateFormat for the surfaces that call formatValue.
 * Outside a PreferencesProvider (tests, the public shared page) it is the
 * card default.
 */
export default function useUnitSystem() {
	const ctx = useOptionalPreferences();
	return normalizeUnitSystem(ctx?.prefs?.unitSystem);
}
